import { render } from "./AppVersionInfoW.vue?vue&type=template&id=51ecb098&scoped=true"
import script from "./AppVersionInfoW.vue?vue&type=script&lang=js"
export * from "./AppVersionInfoW.vue?vue&type=script&lang=js"

import "./AppVersionInfoW.vue?vue&type=style&index=0&id=51ecb098&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51ecb098"]])

export default __exports__